import type { Tamanho } from "@foto/shared";

/**
 * O tamanho de uma imagem, lido do próprio navegador.
 *
 * O servidor não manda as dimensões das fotos (medi-las custaria baixar o original), e o enquadramento
 * é em porcentagem da foto: basta a proporção, que a versão reduzida (`tela`) guarda. O visor de
 * imagens usa a mesma leitura para as versões que chegam sem `tamanho`. Guardado por endereço para
 * não carregar duas vezes.
 */
const lidos = new Map<string, Promise<Tamanho>>();

export function tamanhoDaImagem(url: string): Promise<Tamanho> {
  let promessa = lidos.get(url);
  if (!promessa) {
    promessa = new Promise<Tamanho>((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve({ largura: img.naturalWidth, altura: img.naturalHeight });
      img.onerror = () => reject(new Error("Não foi possível carregar a foto"));
      img.src = url;
    });
    // Se falhar, a próxima tentativa recarrega em vez de repetir o erro guardado.
    promessa.catch(() => lidos.delete(url));
    lidos.set(url, promessa);
  }
  return promessa;
}
